import React, { useState, useEffect, useContext, useCallback } from "react";
import { hungerhubLogo, RightArrow } from "assets/img";
import Testimonial from "components/testimonials/Testimonial";
import classNames from "classnames";
import { MobXProviderContext } from "mobx-react";
import { useNavigate, useLocation } from "react-router-dom";
import { isMediumOrSmallScreen } from "utils/constants/onboardingStep";

const Index = ({ children }) => {
  const { onboardingStore } = useContext(MobXProviderContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [disableButton, setDisableButton] = useState(true);
  const [showSkipButton, setShowSkipButton] = useState(false);
  const [isSkipped, setIsSkipped] = useState(false);
  const [isReload, setIsReload] = useState(false);

  const nextStep = () => {
    if (onboardingStore.error) {
      navigate("/step5");
    } else {
      const step = Number(location?.pathname?.slice(-1));
      const nextStep = isMediumOrSmallScreen && step === 3 ? 5 : step + 1;

      navigate(`/step${nextStep}`);
    }
  };

  const isStep1 = location.pathname == "/step1";
  const isStep2 = location.pathname == "/step2";
  const isStep3 = location.pathname == "/step3";
  const isStep4 = location.pathname == "/step4";
  const isStep5 = location.pathname == "/step5";
  const isStep6 = location.pathname == "/step6";

  const enableButton = (value) => {
    if (isStep1) {
      setDisableButton(value);
    } else if (
      isStep2 &&
      onboardingStore.expected_bag !== "" &&
      onboardingStore.meal_serieses_attributes?.length > 0
    ) {
      setDisableButton(value);
    } else if (
      isStep3 &&
      onboardingStore.expected_bag !== "" &&
      onboardingStore.meal_serieses_attributes?.length > 0 &&
      onboardingStore.meal_allowance_type != "" &&
      onboardingStore.meal_allowance_value !== "" &&
      onboardingStore.enable_meal_delivery !== "" &&
      ((onboardingStore.recieving_days?.length > 0 &&
        onboardingStore.default_date !== "") ||
        onboardingStore.recieving_dates?.length > 0)
    ) {
      setDisableButton(value);
    } else if (isStep4) {
      setDisableButton(value);
    } else if (
      isStep5 &&
      onboardingStore.expected_bag !== "" &&
      onboardingStore.meal_serieses_attributes?.length > 0 &&
      onboardingStore.meal_allowance_type != "" &&
      onboardingStore.meal_allowance_value !== "" &&
      onboardingStore.enable_meal_delivery !== "" &&
      ((onboardingStore.recieving_days?.length > 0 &&
        onboardingStore.default_date !== "") ||
        onboardingStore.recieving_dates?.length > 0) &&
      onboardingStore.user.first_name !== "" &&
      onboardingStore.user.last_name !== "" &&
      onboardingStore.user.email !== "" &&
      onboardingStore.user.phone !== "" &&
      onboardingStore.location.name !== "" &&
      onboardingStore.location.street_number !== "" &&
      onboardingStore.location.street_name !== "" &&
      onboardingStore.location.city !== "" &&
      onboardingStore.location.province !== "" &&
      onboardingStore.location.postal_code !== ""
    ) {
      setDisableButton(value);
    } else setDisableButton(value);
  };

  useEffect(() => {
    onboardingStore.fetchCuisineTypesData();

    const handleResize = () => {
      setScreenHeight({
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setShowSkipButton(isStep4);
  }, [location.pathname]);

  useEffect(() => {
    onboardingStore.setSkippedStep(isSkipped);
  }, [isSkipped]);

  const clonedChildren = React.Children.map(children, (child) => {
    if (isStep5) return React.cloneElement(child, { nextStep: nextStep });
    else return React.cloneElement(child, { disableButton: enableButton });
  });

  useEffect(() => {
    navigate("/step1");
  }, [isReload]);

  const handleUnload = useCallback(() => {
    const unloadHandler = (event) => {
      event.preventDefault();
      event.returnValue = "";
      setIsReload(true);
    };

    window.addEventListener("unload", unloadHandler);

    return () => {
      window.removeEventListener("unload", unloadHandler);
    };
  });

  const backClickHandler = () => {
    const step = Number(location?.pathname?.slice(-1));
    const prevStep = isMediumOrSmallScreen && step === 5 ? 3 : step - 1;

    if (prevStep > 0) navigate(`/step${prevStep}`);
  };

  return (
    <>
      {!isStep6 && (
        <>
          <div className="left-pane">
            <div className="relative flex flex-col h-screen pt-4">
              <img
                className="w-[114px] h-[41px] mb-8"
                src={hungerhubLogo}
                alt="HungerhubLogo"
              />

              <div
                className={`step-one-content py-1 relative ${
                  !isStep4 ? "flex flex-col" : "flex-col"
                } `}
              >
                <div className="w-24 h-11 flex items-center justify-center">
                  {!isStep1 && (
                    <button
                      className="w-24 h-11 flex items-center justify-center gap-2 bg-slate-50 rounded-xl inline-flex"
                      onClick={backClickHandler}
                    >
                      <img
                        className="w-5 h-5"
                        src={RightArrow}
                        alt="BackButton"
                      />
                      <span className="text-indigo-900 font-inter-normal text-base leading-tight">
                        Back
                      </span>
                    </button>
                  )}
                </div>

                <div className="flex-1 mt-2">{clonedChildren}</div>

                {!isStep5 && (
                  <div className="bottom-fixed-div object-bottom mt-4 mb-6">
                    <div className="screen-sm:px-2.5 w-full flex flex-inline">
                      <button
                        disabled={disableButton}
                        onClick={nextStep}
                        className={classNames(
                          "button-class font-inter-medium",
                          {
                            "bg-gray-200": disableButton,
                            "bg-indigo-900": !disableButton,
                          }
                        )}
                      >
                        {isStep1 ? "Customize your meal plan" : "Continue"}
                      </button>

                      {isStep4 && showSkipButton && (
                        <button
                          className="screen-lg:w-6/12 text-indigo-900 font-inter-semibold screen-lg:mb-6 screen-md:mb-6 screen-lg:mt-5 screen-md:mt-5 screen-sm:mb-2 screen-xs:mb-2 screen-md:ml-8"
                          onClick={() => {
                            nextStep();
                            setIsSkipped(true);
                          }}
                        >
                          Skip for now
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="right-pane">
            <Testimonial currentStep={Number(location?.pathname?.slice(-1))} />
          </div>
        </>
      )}

      {isStep6 && (
        <div className="w-full p-3.5">
          <div className="w-full flex screen-lg:items-center screen-lg:justify-center">
            <img
              className="w-[114px] h-[41px] mb-8"
              src={hungerhubLogo}
              alt="HungerhubLogo"
            />
          </div>

          <div className="hidden screen-lg:flex screen-md:flex w-full h-[3px] bg-slate-50"></div>

          {clonedChildren}
        </div>
      )}
    </>
  );
};

export default Index;
